import { AccessLevelEnum } from '@zaoblako/shared/modules/security/enums/access.level.enum';
import { ManualAccessRulesKeyEnum } from '@zaoblako/web/core/models/enums/access-rules/manual/manual-access-rules-key.enum';

type AccessRuleExpression = Record<string, any>;

export const ManualAccessRulesConst: Record<ManualAccessRulesKeyEnum, AccessRuleExpression> = {
  // --- Модуль FRM_AI (ФРМ AI) ---
  // --- Раздел FRM_AI.SECTIONS.MANUAL (Курсы) ---
  [ManualAccessRulesKeyEnum.FROM_AI_MANUAL_WRITE]: {
    'FRM_AI.enabled': true,
    'FRM_AI.sections.MANUAL.tabs.COURSE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  // --- Раздел FRM_AI.SECTIONS.FRM_AI_CHAT (Чат) ---
  [ManualAccessRulesKeyEnum.FROM_AI_CHAT_WRITE]: {
    'FRM_AI.enabled': true,
    'FRM_AI.sections.FRM_AI_CHAT.tabs.FRM_AI_CHAT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  }
};
